/* tslint:disable */
/* eslint-disable */
/**
 * pricing API
 * Pricing service
 *
 * The version of the OpenAPI document: 38.846.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SIdHistoricPrice
 */
export interface SIdHistoricPrice {
    /**
     * 
     * @type {string}
     * @memberof SIdHistoricPrice
     */
    sId?: string;
    /**
     * 
     * @type {string}
     * @memberof SIdHistoricPrice
     */
    symbol?: string;
    /**
     * 
     * @type {string}
     * @memberof SIdHistoricPrice
     */
    closePrice?: string;
    /**
     * 
     * @type {string}
     * @memberof SIdHistoricPrice
     */
    tradeDate?: string;
    /**
     * 
     * @type {string}
     * @memberof SIdHistoricPrice
     */
    sid?: string;
}

/**
 * Check if a given object implements the SIdHistoricPrice interface.
 */
export function instanceOfSIdHistoricPrice(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SIdHistoricPriceFromJSON(json: any): SIdHistoricPrice {
    return SIdHistoricPriceFromJSONTyped(json, false);
}

export function SIdHistoricPriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SIdHistoricPrice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sId': !exists(json, 'sId') ? undefined : json['sId'],
        'symbol': !exists(json, 'symbol') ? undefined : json['symbol'],
        'closePrice': !exists(json, 'closePrice') ? undefined : json['closePrice'],
        'tradeDate': !exists(json, 'tradeDate') ? undefined : json['tradeDate'],
        'sid': !exists(json, 'sid') ? undefined : json['sid'],
    };
}

export function SIdHistoricPriceToJSON(value?: SIdHistoricPrice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sId': value.sId,
        'symbol': value.symbol,
        'closePrice': value.closePrice,
        'tradeDate': value.tradeDate,
        'sid': value.sid,
    };
}

